export default {
  catalog_id_placeholder: '№ ',
  country: 'Țară',
  region: 'Regiune',
  city: 'Oraș',
  district: 'Cartier',
  category: 'Categorie',
  type: 'Tip',
  subtype: 'Subtip',
  purpose: 'Tip tranzacție',
  any: 'Oricare',
  apply: 'Aplică',
  reset: 'Resetează',
  show: 'Afișează filtrul',
  hide: 'Ascunde filtrul',

  purpose_options: {
    sale: 'Vânzare',
    rental: 'Închiriere pe termen lung',
    daily_rent: 'Închiriere pe termen scurt',
    investment: 'Investiție',
    holiday: 'Vacanță / Odihnă',
    commercial_use: 'Utilizare comercială',
    residence: 'Locuință'
  }

}
